<template>
  <section class="content-categories-default">
    <Breadcrumb :links="links"/>
    <div class="content-categories-default-body">
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
          <router-link tag="a" :to="{name: 'RegisterNarration'}" class="content--card-register" style="min-height: 200px; height: initial;">
            <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
          </router-link>
        </div>
        <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="narration in narrations.data" :key="narration.id">
          <div class="content-card-audio" @click="routerPage(narration)">
            <div class="content-card-audio--text">
              <h2>{{ narration.name }}</h2>
            </div>
            <div class="content-card-audio--btns">
              <button class="btn--edit">
                Editar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Meditação',
          routerName: 'Meditation'
        },
        {
          name: 'Narrações',
          routerName: 'ListNarrations'
        },
      ],
    }
  },
  components: {
    Breadcrumb,
  },
  computed: {
    ...mapGetters('Meditation', ['narrations'])
  },
  methods: {
    ...mapActions('Meditation', ['consultNarrations', 'registerCategoryMeditation']),
    routerPage(narration) {
      this.$router.push({
        name: 'EditNarration',
        params: {
          id: narration.id
        },
      });
    },
  },
  mounted() {
    this.consultNarrations();
  }
}
</script>

<style lang="scss">
.content-card-audio {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 200px;
  background: var(--white);
  border-radius: 10px;
  box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
  padding-bottom: 15px;
  margin-bottom: 50px;
  cursor: pointer;
  &--image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 10px 10px 0px 0px;
  }
  &--text {
    padding: 40px 15px 0px 15px;
    h2 {
      font-size: 20px;
      font-family: 'Font Semibold';
      color: var(--black);
      text-align: center;
      margin-bottom: 20px;
    }
  }
  &--btns {
    padding: 0px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn--edit, .btn--delete {
      width: 50%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: 'Font Bold';
      text-transform: uppercase;
      border: 0;
      border-radius: 30px;
      transition: 500ms;
      &:hover,&:focus {
        cursor: pointer;
        opacity: 0.6;
      }
    }
    .btn--edit {
      margin-right: 5px;
      background: var(--yellow);
      color: var(--black);
    }
    .btn--delete {
      margin-left: 5px;
      background: var(--red-2);
      color: var(--white);
    }
  }
}
</style>
